'use client';

import type { ReactNode } from 'react';

import { AuthProvider } from '@/hooks/useAuth';

/** Client providers that must wrap the App Router tree. */
export function AppProviders({ children }: { children: ReactNode }) {
  return <AuthProvider>{children}</AuthProvider>;
}
